<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="ScrollMenu">
	<div class="FullWidth">
		<div class="TopBar">
			<!--Nav Bar-->
			<div class="WholeTopBar">
				<div class="CalendarNavBar">
					<h4 class="FlexItem">School:</h4>
					<!-- <select class="form-control FlexItem SelectWidth" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="SchoolID">
                        <option value="" style="display:none;"></option>
                        <option *ngFor="let o of lstSchool" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
                    </select> -->

					<caass-schoolselector
						[ShowAll]="false"
						[Disabled]="
							loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true
						"
						[TableTypeID]="1"
					>
					</caass-schoolselector>
				</div>
			</div>

			<div class="Buttons">
				<div class="CalendarNavBar" style="margin-left: 20px">
					<h4 class="FlexItem">Selected:</h4>

					<!--Month-->
					<select
						[disabled]="
							loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true
						"
						class="form-control FlexItem SelectWidth"
						name="DisplayMonth"
						(ngModelChange)="onDisplayMonthChange($event)"
						[(ngModel)]="DisplayMonth"
					>
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstMonth" [ngValue]="o">
							{{ o }}
						</option>
					</select>

					<!--Year-->
					<select
						[disabled]="
							loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true
						"
						class="form-control FlexItem SelectWidth"
						name="DisplayYear"
						(ngModelChange)="onDisplayYearChange($event)"
						[(ngModel)]="DisplayYear"
					>
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstYear" [ngValue]="o">
							{{ o }}
						</option>
					</select>

					<button
						[disabled]="
							loadingSchools == true ||
							loadingPrefs == true ||
							loadingDayOps == true ||
							loadingBellSchedule == true ||
							loadingDayEntries == true ||
							DisablePrevious() == true
						"
						class="btn btn-primary"
						style="min-width: max-content; margin: 0px 5px 0px 5px"
						(click)="onPrevious()"
					>
						<i class="fa fa-arrow-left"></i> Previous
					</button>
					<button
						[disabled]="
							loadingSchools == true ||
							loadingPrefs == true ||
							loadingDayOps == true ||
							loadingBellSchedule == true ||
							loadingDayEntries == true ||
							DisableNext() == true
						"
						class="btn btn-primary"
						style="min-width: max-content; margin: 0px 5px 0px 5px"
						(click)="onNext()"
					>
						Next <i class="fa fa-arrow-right"></i>
					</button>
				</div>
			</div>
		</div>

		<!--Manually Created Calendar-->
		<div>
			<!--7 Col Grid for days-->
			<div class="DayGrid">
				<!--Headers-->
				<div class="TableHeader">
					<h4>Sunday</h4>
				</div>
				<div class="TableHeader">
					<h4>Monday</h4>
				</div>
				<div class="TableHeader">
					<h4>Tuesday</h4>
				</div>
				<div class="TableHeader">
					<h4>Wednesday</h4>
				</div>
				<div class="TableHeader">
					<h4>Thursday</h4>
				</div>
				<div class="TableHeader">
					<h4>Friday</h4>
				</div>
				<div class="TableHeader TableRight">
					<h4>Saturday</h4>
				</div>

				<!--Data-->
				<div
					[ngClass]="{
						TableData: true,
						Today: IsToday(o.DayNumber) == true,
						TableRight: (i + 1) % 7 == 0
					}"
					*ngFor="let o of Days; let i = index"
				>
					<caass-school-calendar-entry
						[DayNumber]="o.DayNumber"
						[SchoolDayID]="o.DayID"
						[lstSchoolDay]="lstDayOptions"
						[BellScheduleID]="o.BellScheduleID"
						[lstBellSchedule]="lstBellScheduleOptions"
						[UseSchoolBellSchedule]="UseSchoolBellSchedule"
						[CalendarDate]="o.CalendarDate"
						[user]="user"
						[IsOpen]="o.IsOpen"
						(DayChange)="onDayChange($event)"
						[loadingSchools]="loadingSchools"
						[loadingPrefs]="loadingPrefs"
						[loadingDayOps]="loadingDayOps"
						[loadingBellSchedule]="loadingBellSchedule"
						[loadingDayEntries]="loadingDayEntries"
					></caass-school-calendar-entry>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="TopMargin Buttons">
	<button
		[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
		class="btn btn-primary FlexItem"
		(click)="onUpdate()"
	>
		Update Calendar
	</button>
	<button
		[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
		class="btn btn-primary FlexItem"
		(click)="onReset()"
	>
		Reset Calendar
	</button>
	<button
		[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
		class="btn btn-primary FlexItem"
		(click)="onAdjust()"
	>
		Adjust Settings
	</button>
	<button
		[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
		class="btn btn-primary FlexItem"
		(click)="onTestValid()"
	>
		Test Validity
	</button>
	<button
		[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
		class="btn btn-primary FlexItem"
		(click)="onChangeMultiple()"
	>
		Change Multiple
	</button>
	<button
		[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
		class="btn btn-primary FlexItem"
		(click)="onSetSchedule()"
	>
		Change Schedule
	</button>
</div>

<h3 *ngIf="lstChangedData.length > 0" class="HelpText">Calendar data changed: Press Update to save changes</h3>
